<template>
	<div class="fluid containerp pc_con">
		<!--myHeader></myHeader-->
		<div class="conectBar">
			<div id="editConPhone" class="con_innd" @dragenter="dragConEnter($event)" @drop="onDragConDrop($event)" @dragleave="onDragConLeave($event)" @dragover="dragConover($event)">
				<vue-context-menu :contextMenuData="contextMenuData" @setAllModule="setAllModule()" @addMaterial="addMaterial()" @managementGlobalModule="managementGlobalModule()" @customModule="customModule()" @copyItem="copyItem()">
				</vue-context-menu>
				<!--导航-->
				<div v-if="phoneNav.navheader.mStyle==1" class="navheader ms1" :style="phoneNav.navheader">
					<p @click="back" id="back" class="back" :style="[phoneNav.backStyle,{lineHeight:(parseInt(phoneNav.navheader.height)-20+'px')}]">
						<img src="https://diy.xiaohucloud.com/static/image/balk10.png" /></p>
					<p class="nav_logo" :style="phoneNav.logoStyle" @click="isFuncur(state.phoneNav,{rTitle:'设置手机导航',isEdit:true})">
						<span v-if="phoneNav.namenumber==1">{{phoneNav.mainText.web_name}}</span>
						<img :style="phoneNav.navheaderImg" v-if="phoneNav.namenumber==2" :src="phoneNav.mainText.web_logo" />
					</p>
					<p class="navClick" :style="[phoneNav.iconStyle,{lineHeight:(parseInt(phoneNav.navheader.height)-20+'px')}]"><img :src="phoneNav.mainText.web_icon" /></p>
				</div>
				<div v-if="phoneNav.navheader.mStyle==2" class="navheader ms2" :style="state.phoneNav.navheader">
					<p class="navClick" :style="[phoneNav.iconStyle,{lineHeight:(parseInt(phoneNav.navheader.height)-20+'px')}]"><img :src="phoneNav.mainText.web_icon" /></p>
					<p id="back" class="back nav_logo" :style="phoneNav.logoStyle" @click="isFuncur(phoneNav,{rTitle:'设置手机导航',isEdit:true})">
						<span v-if="phoneNav.namenumber==1">{{phoneNav.mainText.web_name}}</span>
						<img :style="phoneNav.navheaderImg" v-if="phoneNav.namenumber==2" :src="phoneNav.mainText.web_logo" />
					</p>
					<div class="search_icon">
						<img id="headerSearch" :src="phoneNav.navheader.url||'https://diy.xiaohucloud.com/static/image/search_icon.png'" />
					</div>
					<p id="placeholderTxt" class="placeholderTxt">
						<input id="searchValue" type="text" :placeholder="showData[param.lang][0]" class="searchCon" />
						<button @dblclick="goProduct()">{{showData[param.lang][1]}}</button>
					</p>
				</div>
				<div id="navBg" class="bg_net0"></div>
				<div id="menu" :class="['navigation',{ms1_nav:phoneNav.navheader.mStyle==1,ms2_nav:phoneNav.navheader.mStyle==2}]">
					<ul class="navItem" :style="{background:router.hoverStyle.background}">
						<li v-if="router.isLanguage" class="mltilingual-li">
							<div id="mltilingual" class="mltilingual-phone" @mouseenter="showEdit()" @mouseleave="hideEdit()" :style="router.langugeQx.setDivStyle">
								<p class="edit_con" style="z-index:100;">
									<span @click="isFuncur(router.langugeQx,{rTitle:'编辑多语言',isEdit:true})">编辑多语言</span>
								</p>
								<div v-if="router.langugeQx.styleType==1" class="styleType1">
									<div class="title" :style="router.langugeQx.setFontStyle">
										<span>{{curMltilingual}}<em></em></span>
									</div>
									<ul class="ul_item">
										<li v-for="(item,index) in showLang" :key="index">
											<a :href="router.langugeQx.domain+'?lang='+item.code">{{item.lang_name}}</a>
										</li>
										<!--li>
											<a :href="router.langugeQx.domain+'?lang=en'">English</a>
										</li-->
									</ul>
								</div>
								<div v-if="router.langugeQx.styleType==2" class="styleType2">
									<a v-for="(item,index) in showLang" :key="index" :href="router.langugeQx.domain+'?lang='+item.code" :style="router.langugeQx.setFontStyle"><span>{{item.lang_name}}</span></a>
									<!--a :href="router.langugeQx.domain+'?lang=en'" :style="router.langugeQx.setFontStyle"><span>English</span></a-->
									<!--p :style="{backgroundColor:router.langugeQx.setFontStyle.color}" class="p-border"></p-->
								</div>
							</div>
						</li>
						<li v-if="item.is_show&&item.url!='newsDetail'" v-show="item.url!='productDetail'" class="first_item" v-for="(item,it) in navItem" :key="it">
							<div :class="['la_item',{isHover:item.is_show},{active:activeRoute == item.id}]" @click="goDesign(item)" :style="router.tTextStyle"><i v-if="item.secondNav.length" class="g-fr over" :style="[router.hoverStyle,{color:phoneNav.navheader.curColor,background:phoneNav.navheader.curBackground}]">{{item.secondNav.length}}</i>{{item.column_name}}</div>
							<ul v-if="item.secondNav.length" class="seconNav">
								<li v-if="second.is_show&&item.url!='newsDetail'" v-for="(second,sec) in item.secondNav" :key="sec">
									<div :class="['sec_item',{isHover:second.is_show},{active:activeRoute == second.id}]" @click="goDesign(second)" :style="router.tTextStyle"><i v-if="second.thirdNav.length" class="g-fr over" :style="router.hoverStyle">{{second.thirdNav.length}}</i>{{second.column_name}}</div>
									<ul v-if="second.thirdNav.length" class="thirdNav">
										<li v-if="third.is_show&&item.url!='newsDetail'" :class="['thir_item',{active:activeRoute == third.id}]" v-for="(third,thirIndex) in second.thirdNav" @click="goDesign(third)" :key="thirIndex" :style="router.tTextStyle">
											{{third.column_name}}
										</li>
									</ul>
								</li>
							</ul>
						</li>
					</ul>
				</div>

				<div :class="['conect_inner',{con_padd:state.footer.isShow}]">
					<template v-for="(i,tIndex) in getDataCur.stream" class="g-cf in_outer">
						<!--满屏容器-->
						<div :id="i.allId" v-if="i.tName=='fullScreen'" :class="['in_inner fullScreen',{'enter':i.isStreamColumn}]" @mouseover="hoverConect(i)" @mouseenter="enterConect(i)" @mouseleave.self="leaveConect(i)" @dragover.prevent="onStreamOver($event,i)" @dragenter="onStreamEnter($event,i,getDataCur.stream)" @drop.stop='inStreamDrop($event,i)' @dragleave="onStreamLeave($event,i)" draggable="true" @dragstart="handleDragStart($event,i,getDataCur.stream)" @dragend="handleDragEnd($event,i,getDataCur.stream)" :style="i.zinStyle">
							<div class="multi_edit f_hv" style="right: 0;">
								<span @click="isFuncur(i,{rTitle:'设置满屏容器',isEdit:true})">设置{{i.tText}}</span>
								<span class="icon delete" @click="delModule(i)"></span>
							</div>
              <!--lyf 满屏 2020-07-21-->

              <img class="fullScreenBjImg" :src="i.mImage.url" style="display: none;" />
							<div :id="tIndex" class="resizeMe" :style="i.conStyle" @contextmenu="showMenu(i)">
								<mConet v-for="(irt,index) in i.itemInner" class="outmodule" :key="index" v-if="irt.isShow" :itemMdata="irt" :itemInner="i.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
							</div>
						</div>
						<!--自由容器-->
						<div :id="i.allId" v-if="i.tName=='freeContainer'&&i.isShow" :class="['in_inner freeContainer',{'enter':i.isStreamColumn}]" @mouseover="hoverConect(i)" @mouseenter="enterConect(i)" @mouseleave.self="leaveConect(i)" @dragover="onStreamOver($event,i)" @dragenter="onStreamEnter($event,i,getDataCur.stream)" @drop.stop='inStreamDrop($event,i)' @dragleave="onStreamLeave($event,i)" :style="i.zinStyle">
							<div class="activ_con"><span @click="setUpDown(i,-1)" v-show="i.isShowUp" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="i.isShowDown" class="down_icon"></span></div>
							<div class="multi_edit f_hv" style="right: 0;">
								<span @click="isFuncur(i,{rTitle:'设置自由容器',isEdit:true})">设置{{i.tText}}</span>
								<span class="icon delete" @click="delModule(i)"></span>
							</div>
							<div @contextmenu="showMenu(i)" v-dragresize="getDataFree" :id="tIndex" class="resizeMe" :style="i.conStyle">
								<mConet v-for="(irt,index) in i.itemInner" :class="[{outmodule:irt.fullScreen}]" :key="index" v-if="irt.isShow" :itemMdata="irt" :itemInner="i.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
							</div>
						</div>
						<!--多列展示-->
						<div :id="i.allId" @contextmenu="showMenu(i)" :data-index="tIndex" v-if="i.tName=='multiColumnContainer'&&i.isShow" @mouseenter="enterConect(i)" @mouseover="hoverConect(i)" @mouseleave.self="leaveConect(i)" :class="['in_inner multi_con g-cf', {'enter':i.isStreamColumn}]" :style="i.zinStyle">
							<!--div class="activ_con"><span @click="setUpDown(i,-1)" v-show="i.isShowUp" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="i.isShowDown" class="down_icon"></span></div-->
							<div :class="['multi_edit f_hv',{hover:i.isHover}]" style="right: 0;">
								<span @click="isFuncur(i,{rTitle:'设置多列排版',isEdit:true})">设置{{i.tText}}</span>
								<!--span class="icon animation" @click="funcEmition(i)"><i>设置动画</i></span>
								<span class="icon style"><i>设置样式</i></span>
								<span class="icon borderhid"><i>隐藏边框</i></span-->
								<span class="icon delete" @click="delModule(i)"><i></i></span>
							</div>
							<div :id="tIndex" class="resizeMe" :style="[i.conStyle,{visibility:i.isShow?'visible':'hidden'}]">
								<div v-for="(it,index) in i.labelTitle" :style="[{height:i.conStyle.height,width:it.styleCon.width}]" :class="['clm',{'enter':i.isStreamColumn},'clm'+index]" v-if="it.isShow" @dragover="onStreamOver($event,i,it)" @dragenter="onStreamEnter($event,i,it)" @drop.stop="inStreamDrop($event,i,it)" @dragleave="onStreamLeave($event,i,it)">
									<div class=" clm_inner" :style="i.conStyle">
										<div class="area_conn" :style="i.conStyle">
											<template v-for="(imy,inde) in it.itemInner">
												<mConet v-if="imy.isShow" class="outmodule" :itemMdata="imy" :key="inde" :itemInner="it.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!--标签展示-->
						<div :id="i.allId" @contextmenu="showMenu(i)" :style="i.zinStyle" v-if="i.tName=='labelContainer'&&i.isShow" @mouseenter="enterConect(i)" @mouseover="hoverConect(i)" @mouseleave.self="leaveConect(i)" draggable="true" @dragstart="handleDragStart($event,i,getDataCur.stream)" @dragend="handleDragEnd($event,i,getDataCur.stream)" :class="['in_inner labelContainer',{'enter':i.isStreamColumn}]">
							<!--div class="activ_con"><span @click="setUpDown(i,-1)" v-show="i.isShowUp" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="i.isShowDown" class="down_icon"></span></div-->
							<div class="multi_edit f_hv" style="right: 0;">
								<span @click="isFuncur(i,{rTitle:'设置标签展示',isEdit:true})">设置{{i.tText}}</span>
								<span class="icon delete" @click="delModule(i)"></span>
							</div>
							<div class="tit_con" :class="[{labelListOne:i.diretionM==1,labelListTwo:i.diretionM==2,righterdUl:i.setulStyle==3&&i.diretionM==2}]">
								<ul class="g-cf" id="labelTitle" :class="['g-cf',{centerUl:i.setulStyle==1&&i.diretionM==1,leftUl:i.setulStyle==2&&i.diretionM==1,rightUl:i.setulStyle==3&&i.diretionM==1}]" :style="i.labelUlStyle">
									<li v-for="(ite,index) in i.labelTitle" :class="['labelList',{'no_data':!ite.labelTitle}]" :style="i.labelTitleBasis">
										<p @click="setLabelItem(i,ite)" class="title" :style="[{borderRadius:i.labelTitleBasis.borderRadius},ite.curItem==i.curItem?i.labelTitleStyleHover:i.labelTitleStyle]">{{ite.labelTitle}}<i @click="deleteLabel(i,ite,index)">x</i></p>
									</li>
								</ul>
								<div class="lbl_con">
									<div v-for="(it,index) in i.labelTitle" class="conStyle" :style="it.conStyle" v-show="i.isShow&&it.curItem == i.curItem" @dragover="onStreamOver($event,i,it)" @dragenter="onStreamEnter($event,i,it)" @drop.stop="inStreamDrop($event,i,it)" @dragleave="onStreamLeave($event,i,it)" style="min-height: 100px;">
										<template v-if="ilbl.isShow&&!ilbl.fontShowilbl" v-for="(ilbl,dex) in it.itemInner">
											<mConet v-if="it.curItem == i.curItem" :key="dex" :itemMdata="ilbl" :itemInner="i.itemInner" v-on:removeComponent="removeComponent" class="outmodule" @isFuncur="isFuncur"></mConet>
										</template>
									</div>
								</div>
							</div>
						</div>

						<!--滑屏容器-->
						<div @contextmenu="showMenu(i)" :data-index="tIndex" v-if="i.tName=='swiperContainer'&&i.isShow" @mouseenter="enterConect(i)" @mouseover="hoverConect(i)" @mouseleave.self="leaveConect(i)" :class="['swiperContainer in_inner g-cf', {'enter':i.isStreamColumn}]" :style="i.zinStyle">
							<!--div class="activ_con"><span @click="setUpDown(i,-1)" v-show="tIndex>0" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="tIndex<getDataCur.stream.length-1" class="down_icon"></span></div-->
							<div :class="['multi_edit f_hv',{hover:i.isHover}]">
								<span @click="isFuncur(i,{rTitle:'设置滑屏容器',isEdit:true})">设置{{i.tText}}</span>
								<span class="icon delete" @click="delModule(i)"><i></i></span>
							</div>
							<div :id="i.allId" class="swiper-container">
								<div class="swiper-wrapper">
									<div class="swiper-slide" v-for="(it,index) in i.labelTitle" v-if="it.isShow" :class="['clm',{'enter':i.isStreamColumn},'clm'+index]" @dragover="onStreamOver($event,i,it)" :style="it.layoutOuterStyle" @dragenter="onStreamEnter($event,i,it)" @drop.stop="inStreamDrop($event,i,it)" @dragleave="onStreamLeave($event,i,it)">
										<div class="area_conn" :style="it.zinStyle">
											<div class="et_ct">{{it.labelTitle}}</div>
											<template v-for="(imy,inde) in it.itemInner">
												<mConet v-if="imy.isShow" :itemMdata="imy" :key="inde" :itemInner="it.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
											</template>
										</div>
									</div>
									<!--div class="swiper-slide">slide 22333</div>
								<div class="swiper-slide">Slide 3</div-->
								</div>
							</div>
							<!-- 如果需要分页器 -->
							<div class="swiper-pagination"></div>
							<!-- 如果需要导航按钮 -->
							<!--div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div-->
							<!-- 如果需要滚动条 -->
							<div class="swiper-scrollbar"></div>
						</div>
						<!--滑屏容器-->

					</template>
					<!--添加新容器-->
					<div :class="{'enter':isAddNew}" @drop.stop='inAddNewDrop($event)' @dragover='inAddNewOver($event)' class="g-cf addMern">
						<div class="dragNew" @click="sideConNone()">
							<p></p>
							<span>可以拖模块进来</span>
						</div>
					</div>
				</div>
			</div>
			<div v-if="state.footer.isShow" class="nav-footer phoneedit">
				<div class="edit_con f_hv">
					<span @click="isFuncur(state.footer,{rTitle:'设置底部导航',isEdit:true})">设置底部导航</span>
					<span class="icon delete" @click="delModule({tName:'footerNav'})"></span>
				</div>
				<footer>
					<div v-for="(item,index) in state.footer.itemNav" :key="index" v-bind:class="['f_item',{active:activeRoute == item.id}]">
						<div @click="goDesign(item,'footer')" class="link">
							<span :style="[{backgroundImage:state.footer.iconNav},item.iStyle]" :class="['rout_ctive','tab-' + index]"></span>
							<em>{{item.text}}</em>
						</div>
					</div>
				</footer>
			</div>
		</div>
		<uiDialog v-if="editDial.isEdit" v-on:recoent="recoent" :itemMdata="itemMdata" :editDial='editDial'></uiDialog>
	</div>
</template>
<script>
	import Vue from 'vue'
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
	import mConet from './mConet.vue'
	import bus from '@/common/bus.js'
	import api from '@/api/$ajax.js'
	var vue = new Vue();
	import uiDialog from './m/uiDialog.vue'

	export default {
		name: 'xIndex2',
		components: {
			mConet,
			uiDialog
		},
		beforeCreate() {
			//debugger
		},
		created() {

			var ts = this;
			var temp = ts.$route.params.param;
			// var stream = ts.getDataCur.stream;
			var objAll = {
				id: ts.param.id,
				type: ts.param.type,
				token: ts.param.token,
				column_id: ts.param.version_id + "000",
				version_id: ts.param.version_id
			};

			if(ts.param.param.endsWith(ts.param.version_id + "000")) {

				ts.getAllLocalData(ts.param);
				ts.getWebInfo();
				ts.getData2();
				ts.setDelayed(temp);

			} else {
         
				ts.getData(ts.param);
				ts.getData2();
				ts.getWebInfo();
				ts.getAllSite(objAll);
			}

			var stream = ts.getDataCur.stream;

			ts.router.langugeQx.domain = ts.$route.query.domain_url;
			ts.router.langugeQx.curMltilingual = ts.$route.query.lang == "en" ? "English" : "中文";
			ts.phoneNav.navheader.mStyle = ts.phoneNav.navheader.mStyle || 1;

			if(stream && stream.length) {
				for(let j = 0; j < stream.length; j++) {
					stream[j].isHover = false;
					stream[j].isStopPropagation = false;
				}
			}
			ts.orderbyId();
			/*素材库的使用功能*/
			bus.$on('onMaterial', (id, data) => {
				var ts = this;
				var item = {};
				ts.materialId = id;
				var stream = ts.getDataCur.stream;
				var zIndexLen = stream.length;
				item = JSON.parse(data);
				item.zinStyle.zIndex = zIndexLen;
				if(stream.length > 1) {
					stream.forEach(function(v, i) {
						if(i == 0) {
							v.isShowUp = false;
							v.isShowDown = true;
						} else {
							v.isShowUp = true;
							v.isShowDown = true;
						}
					});
					item.isShowUp = true;
					item.isShowDown = false;
				}

				item.allId = 'm' + ts.$utils.GenNonDuplicateID();
				var item = JSON.parse(JSON.stringify(item));
				for(let i = 0; item.itemInner.length > i; i++) {
					item.itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
				}
				ts.pushItemStream(item);
				setTimeout(function() {
					var h = $(".conect_inner ").height() - $("#editConPhone").height() - 60;
					$("#editConPhone").scrollTop(h);
				}, 600);
			});
			//ts.initFooterData();
			ts.getLang();
			setTimeout(function() {
				mProductShow.initLoad(ts.param.company_id);
			}, 400);

		},
		mounted() {

			var ts = this;
			var stream = ts.getDataCur.stream;
			for(let j = 0; stream.length > j; j++) {
				if(stream[j].tName == 'labelContainer') {
					ts.labelContainer = stream[j];
					//ts.labelContainerId = "labelContainer" + j;
					xIndex2.label(ts.labelContainer.allId, ts.labelContainer);

				} else if(stream[j].tName == "swiperContainer") {

					$("body").addClass("swiperHover");
					//debugger
				}
			};
		},
		data() {
			return {
				isMultiColumn: false,
				isConLeave: false,
				id: this.$route.params.id,
				fontFocus: false,
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					column_id: this.$route.query.column_id,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					manage: this.$route.query.manage,
					domain_url: this.$route.query.domain_url,
					mobile_version_id: this.$route.query.mobile_version_id,
					pc_version_id: this.$route.query.pc_version_id,
					version_id: this.$route.query.mobile_version_id
				},
				preview: '/pc/t2/' + this.$route.params.id + "/",
				itemMdata: {},
				navItem: [],
				dragging: {},
				allItem: [],
				mainText: {},
				showData: {
					en: ['Please enter the product you are searching', 'search'],
					cn: ["请输入要搜索的产品", "搜索"],
					tw: ["請輸入要搜索的產品", "搜索"], //繁体中文
					jp: ["検索する製品を入力してください", "検索する"], //日语
					kr: ["검색 할 제품을 입력하십시오", "검색"], //韩语
					de: ["Bitte geben Sie das zu suchende Produkt ein", "Suche"], //德语
					ru: ["Пожалуйста, введите продукт для поиска", "Поиск"], //俄语
					fr: ["Veuillez entrer le produit à rechercher", "Chercher"], //法语
					th: ["โปรดป้อนผลิตภัณฑ์เพื่อค้นหา", "ค้นหา"], //泰语
					ar: ["الرجاء إدخال المنتج للبحث", "بحث"], //阿拉伯语
					es: ["Por favor, introduzca el producto para buscar", "Buscar"], //西班牙语
					pt: ["Por favor, insira o produto para pesquisar", "Pesquisar"], //葡萄牙语
					ta: ["தேட தயாரிப்பு உள்ளிடவும்", "தேடல்"], //泰米尔语
					hi: ["कृपया खोज करने के लिए उत्पाद दर्ज करें", "खोजें"], //印地语
					it: ["Inserisci il prodotto per la ricerca", "Cerca"], //意大利语
					id: ["Silakan masukkan produk untuk dicari", "Cari"] //印尼语
				},
				editDial: {
					isEdit: false,
					rTitle: "设置自由容器",
				},
				contextMenuData: {
					menuName: this.$utils.guid(),
					axios: {
						x: null,
						y: null
					},
					menulists: [{
							fnHandler: 'setAllModule',
							btnName: '设置为全站模块'
						},
						{
							fnHandler: 'copyItem',
							btnName: '复制模块'
						},
						{
							fnHandler: 'customModule',
							btnName: '设置为自定义模块'
						}
					]
				},
				isAddNew: false,
				showLang: [],
				curMltilingual: "",
				token: this.$route.query.token
			}
		},
		methods: {
			initFooterData() {
				//var state.footer.itemNav
			},
			getLang() {
				var ts = this;
				api.get('/api/data/lang', false, {}, r => {
					if(r.code == 422) {
						return;
					}
					var langList = r.data.lang_list;
					ts.showLang = [];
					for(var i = 0; langList.length > i; i++) {
						// debugger
						if(langList[i].code == ts.param.lang) {
							ts.curMltilingual = langList[i].lang_name;
						}
						ts.showLang = langList;

					}
				});
			},
			goProduct() {
				let ts = this;
				let paramUrl = "";
				let columnList = JSON.parse(localStorage.getItem("columnList")) || [];
				for(let i = 0; columnList.length > i; i++) {
					if(columnList[i].url == "productList") {
						paramUrl = columnList[i].id;
					}
				}

				window.open(ts.preview + paramUrl + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type +
					'&pc_version_id=' + ts.param.pc_version_id + '&mobile_version_id=' + ts.param.mobile_version_id + '&lang=' + ts.param.lang + '&keyword=' + $('#searchValue').val());

			},
			showEdit() {
				if($('.edit_con').css('display') == 'block') {
					$('.navigation').addClass('active');
				} else {
					$('.navigation').removeClass('active');
				}
			},
			hideEdit() {
				$('.navigation').removeClass('active');
			},
			showUl() {
				$('.styleType1 .ul_item').animate({
					height: 'toggle'
				});
				event.stopPropagation();
			},
			getStyle() {
				let ts = this;
				var Style = JSON.parse(localStorage.getItem(ts.param.id + ts.param.type + "itemAllStyle"));
				ts.router.hoverStyle = Style.hoverStyle;
				ts.router.tTextStyle = Style.tTextStyle;
				ts.router.langugeQx = Style.langugeQx;
			},
			back() {
				this.$router.go(-1);
			},
			goDesign(item, flag) {
				//debugger
				if(flag != 'footer' && !item.is_enable) {
					return;
				}
				var link = item.id;
				if(!link) {
					return;
				}
				// console.log(link)
				// debugger

				let ts = this;
				if(item.url && item.url.indexOf("http") > -1) {
					location.href = item.url;
					return;
				}
				if(link) {
					if(Number(link)) {
						location.href = ts.preview + link + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + ts.param.domain_url + '&mobile_version_id=' + ts.param.mobile_version_id + '&lang=' + ts.param.lang;
					} else if(link.indexOf("http") != -1) {
						location.href = link;
					} else {
						location.href = ts.preview + link + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type + '&pc_version_id=' + ts.param.pc_version_id + '&domain_url=' + ts.param.domain_url + '&mobile_version_id=' + ts.param.mobile_version_id + '&lang=' + ts.param.lang;
					}
				}
			},
			addTitle(i) {
				var newlabelTitle = {
					labelTitle: "标签" + (i.labelTitle.length + 1),
					curItem: i.labelTitle.length,
					cur: false,
					is_show: 1,
					conStyle: {
						paddingTop: '0',
						paddingLeft: '0',
						paddingRight: '0',
						paddingBottom: '0',
						borderWidth: '0',
						height: "220px"
					},
					lblClass: "long_i1",
					itemInner: []
				}
				i.labelTitle.push(newlabelTitle);
			},
			deleteLabel(i, list, index) {
				i.labelTitle && i.labelTitle.splice(i.labelTitle.indexOf(list), 1);
				i.itemInner && i.itemInner.splice(index, 1);
				//console.log(index);
			},
			enterConect(it) {
				console.log("enterConect......");
				if(it.isStopPropagation) {
					//console.log("isStopPropagation");
					return;
				}
				it.isHover = true;
				var zin = JSON.parse(JSON.stringify(it.zinStyle));
				it.curIndex = zin.zIndex;
				it.zinStyle.zIndex = 100;
			},
			hoverConect(it) {
				if(it.isStopPropagation) {
					// console.log("isStopPropagation");
					return;
				}
				it.isHover = true;
			},
			leaveConect(it) {
				// console.log("leaveConect");
				// mStopPropagation(flag);
				it.isHover = false;
				it.isStopPropagation = false;
				it.zinStyle.zIndex = it.curIndex;
			},
			showMenu(item) {
				let ts = this;
				var faAll = false;
				var allSite = JSON.parse(localStorage.getItem(ts.param.mobile_version_id + "000")) || [];
				ts.transferIndex = item;
				event.preventDefault();

				if(allSite.itemCon && !Array.isArray(allSite)) {
					allSite = allSite.itemCon[ts.param.mobile_version_id + "000"].stream;
				}

				if(!!item.allId) {
					//debugger
					for(var i = 0; allSite.length > i; i++) {
						if(allSite[i].allId == item.allId) {
							faAll = true;
						}
					}
				}

				if(faAll) {

					ts.contextMenuData.menulists[0].btnName = "管理全局模块";
					ts.contextMenuData.menulists[0].fnHandler = "managementGlobalModule";
				} else {
					ts.contextMenuData.menulists[0].btnName = "设置为全局模块";
					ts.contextMenuData.menulists[0].fnHandler = "setAllModule";
				}

				if(ts.param.manage == 1) {
					ts.contextMenuData.menulists[0].btnName = "加入素材库";
					ts.contextMenuData.menulists[0].fnHandler = "addMaterial";
				}

				var x = event.clientX;
				var y = event.clientY;
				ts.contextMenuData.axios = {
					x,
					y
				}
			},
			addMaterial(e) {
				let ts = this;
				// debugger
				// console.log(ts.getDataCur.stream.indexOf(ts.transferIndex));
				let material = localStorage.getItem('material') || '{}';

				if(material !== '{}') {
					material = JSON.parse(material);
					if(ts.materialId != -1) {
						material.id = ts.materialId;
					}
					material.config = JSON.stringify(ts.transferIndex);
					material.type = ts.param.type;
					material.url = ts.param.domain_url;
					api.post('/api/effect/save', true, material, r => {
						if(r.code == 422) {
							// console.log(r.message);
							return;
						}
						vue.$msg('保存成功!');
					});
				}

				//debugger;
			},
			customModule(e) {
				let ts = this;
				bus.$emit('onCustomModule', ts.transferIndex);
			},
			setAllModule(e) {
				let ts = this;
				ts.transferIndex.allId = ts.transferIndex.allId || "m" + ts.$utils.GenNonDuplicateID();
				//debugger;
				var obj = {
					id: ts.param.id,
					guid: ts.$utils.guid(),
					version_id: ts.param.version_id,
					type: ts.param.type,
					order: ts.transferIndex
				}
				ts.setItemSite(obj);
				ts.orderbyId(); //this.orderbyId();
			},
			copyItem(e) {
				let ts = this;
				var obj = {
					index: ts.getDataCur.stream.indexOf(ts.transferIndex),
					order: JSON.parse(JSON.stringify(ts.transferIndex))
				}
				// debugger;
				obj.order.allId = "m" + ts.$utils.GenNonDuplicateID();
				if(obj.order.tName == "columnLayout" || obj.order.tName == "fullScreen" || obj.order.tName == "freeContainer") {
					for(let i = 0; obj.order.itemInner.length > i; i++) {
						obj.order.itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
					}
				} else if(obj.order.tName == "labelContainer") {
					for(let j = 0; obj.order.labelTitle.length > j; j++) {
						let itemInner = obj.order.labelTitle[j].itemInner;
						for(let i = 0; itemInner.length > i; i++) {
							itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
						}
					}
				}
				ts.copyModule(obj);
				ts.orderbyId();
			},
			isFuncur(i, item) {

				let ts = this;
				i.isEdit = true; //console.log(i);
				ts.editDial = item;
				ts.itemMdata = i;
				event.stopPropagation();
			},
			sideConNone() {
				this.state.flag = "onItem0";
			},
			getData2() {
				let ts = this;
				ts.router.navBarItem = [];
				api.get('/api/data/columnList?template_id=' + ts.param.id + "&m=index&version_id=" + ts.param.version_id, false, {}, r => {
					if(r.code == 422) {
						console.log(r.message);
						return;
					}

					var list = r.data.list;
					var firstList = [];
					for(let i = 0; list.length > i; i++) {
						list[i].secondNav = [];
						if(list[i].parent_id == 0) {
							firstList.push(list[i])
						}
					}

					for(let i = 0; firstList.length > i; i++) {
						for(let k = 0; list.length > k; k++) {
							list[k].thirdNav = [];
							if(firstList[i].id == list[k].parent_id) {
								firstList[i].secondNav.push(list[k])
							}
						}
					}

					for(let i = 0; firstList.length > i; i++) {
						for(let k = 0; firstList[i].secondNav.length > k; k++) {
							for(let j = 0; list.length > j; j++) {
								if(firstList[i].secondNav[k].id == list[j].parent_id) {
									firstList[i].secondNav[k].thirdNav.push(list[j])
								}
							}
						}
					}

					ts.navItem = firstList;
				});
			},
			getWebInfo() {
				let ts = this;
				api.get('/api/data/getWebInfo', true, {}, function(data) {
					ts.phoneNav.mainText = data.data;
					//debugger
				});
			},
			setLabelItem(i, item) {
				for(let k = 0; i.labelTitle.length > k; k++) {
					i.labelTitle[k].cur = false;
				}

				item.cur = true;
				i.curItem = item.curItem;
			},
			getDataFree(v) {
				let ts = this;
				ts.getDataCur.stream[v.el].draging = true;
				ts.getDataCur.stream[v.el].conStyle.height = v.height;
			},
			isfontFocus(flag) {
				// console.log("flag:" + flag);
				this.fontFocus = flag;
			},
			recoent(itemMdata) {
				//this.itemEditCur(null);
			},
			onDragConLeave(event) {
				this.isConLeave = true;
				//console.log("离开外层标准流容器");
			},
			dragConEnter(event) {
				//console.log("进入外层标准流容器");
			},
			onDragConDrop(event) {

			},
			managementGlobalModule() {
				let ts = this;
				var url = '/pc/t2/' + ts.$route.params.id + "/" + ts.$route.query.mobile_version_id + '000?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&mobile_version_id=' + ts.$route.query.mobile_version_id + '&pc_version_id=' + ts.$route.query.pc_version_id + '&domain_url=' + ts.$route.query.domain_url + '&lang=' + ts.$route.query.lang;
				window.open(window.location.origin + url);
			},
			dragConover(event, i) {
				event.preventDefault();
			},
			handleDragStart(e, item, nav) {
				this.dragging = item;
				//c
			},
			onStreamEnter(event, item, nav) {
				console.log("进入标准流容器");
				let ts = this;
				var Id = [];

				$(".multi_con").each(function(v) {
					var h = $(this).height();
					$(this).find(".clm").height(h);
				});

				event.preventDefault();
				event.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
				if(item === ts.dragging) {
					return;
				}

				const newItems = [...nav];
				const src = newItems.indexOf(ts.dragging);
				const dst = newItems.indexOf(item);
				newItems.splice(dst, 0, ...newItems.splice(src, 1));
				/*for(let i = 0; i < newItems.length; i++) {
					Id[i] = newItems[i].id;
				};
				debugger;*/
				ts.allItem = newItems;
				console.dir(newItems);
			},
			onStreamOver(event, i) {
				i.isStreamColumn = true;
				event.dataTransfer.dropEffect = 'move';
				console.log("进入标准流容器(移动阶段 )");
			},
			onStreamLeave(event, i) {
				i.isStreamColumn = false;
				//console.log("离开标准流容器标准流容器");
			},
			handleDragEnd(e, item, nav) {
				let ts = this;
				ts.dragging = null;
				if(ts.allItem.length) {
					ts.getDataCur.stream = ts.allItem;
				}

				//debugger
				//console.log("handleDragEnd："+ nav);
			},
			recomponent(comp) {
				var posCom = this.getDataCur.posCom;
				if(posCom.length) {
					for(var j = 0; posCom.length > j; j++) {
						posCom.splice(posCom.indexOf(comp), 1);
					}
				}
			},
			inStreamDrop(event, i, it) {
				console.log("拖入" + i.tText);
				let dt = this;
				event.preventDefault();
				i.isStreamColumn = false;

				if(!dt.state.curOrder) return;
				let obj = dt.state.curOrder;
				let itemCon = [];
				let stream = dt.getDataCur.stream;

				if(dt.state.curOrder.tName == "footerNav") {
					dt.state.footer.isShow = true;
					dt.state.footer.tName = dt.state.curOrder.tName;
					let footerItem = [];
					let columnList = JSON.parse(localStorage.getItem("columnList"));
					for(let k = 0; columnList.length > k; k++) {
						if(columnList[k].url == "productList" || columnList[k].url == "newsList" || columnList[k].url == "productList") {
							let clmList = {
								pagePath: "pages/index/index",
								text: columnList[k].column_name,
								id: String(columnList[k].id),
								isCouter: true,
								is_enable: true,
								class: "tab_0",
								color: "#888",
								iconPath: "https://diy.xiaohucloud.com/static/image/indexIcon.png",
								selectedColor: "#2873ff",
								iStyle: {},
								link: String(columnList[k].id),
								url: String(columnList[k].id)
							};
							footerItem.push(clmList);
						}
					}
					dt.mFooter({
						itemNav: footerItem,
						isShow: true
					});
					return;
				}

				if(dt.state.curOrder.parentStyle && dt.state.curOrder.parentStyle.height > i.conStyle.height) {
					i.conStyle.height = (dt.state.curOrder.parentStyle.height + 20) + "px";
				}

				let item = JSON.parse(JSON.stringify(obj));
				item.order = itemCon.length + 1;

				if(obj.mClass == "Typesetting") {
					if(item.tName == "swiperContainer") {
						for(let i = 0; item.labelTitle.length > i; i++) {
							item.labelTitle[i].zinStyle.width = "100%";
						}
						$("body").addClass("swiperHover");
					}

					dt.pushItemStream(item);
					stream.forEach(function(v, i) {
						if(i == 0) {
							v.isShowUp = false;
							v.isShowDown = true;
						} else if(i == stream.length - 1) {
							v.isShowUp = true;
							v.isShowDown = false;
						} else {
							v.isShowUp = true;
							v.isShowDown = true;
						}
					});
					dt.setCurOrder(null);
					return;
				}

				item.allId = "m" + dt.$utils.GenNonDuplicateID();

				if(i.tName == "labelContainer" || i.tName == "multiColumnContainer" || i.tName == "swiperContainer") { //标签展示
					var flag = true;
					for(let k = 0; i.labelTitle.length >= k; k++) {
						it.itemInner.push(item);
						dt.setCurOrder(null);
						return;
					}
				}

				item.column = it || -1;
				dt.pushItemStreamItem({
					i,
					item
				});
			},
			onAddNewEnter(event) {
				// console.log("进入新增容器(进入阶段 )");
				event.preventDefault();
			},
			inAddNewDrop(event) {
				//console.log("拖入新增容器");
				event.preventDefault();
				var dt = this;
				if(!dt.state.curOrder) return;
				var item = dt.state.curOrder;
				var stream = dt.getDataCur.stream;
				if(dt.state.curOrder.tName == "footerNav") {
					dt.state.footer.isShow = true;
					dt.state.footer.tName = dt.state.curOrder.tName;
					let footerItem = [];
					let columnList = JSON.parse(localStorage.getItem("columnList"));
					for(let k = 0; columnList.length > k; k++) {
						if(columnList[k].url == "productList" || columnList[k].url == "newsList" || columnList[k].url == "productList") {
							let clmList = {
								pagePath: "pages/index/index",
								text: columnList[k].column_name,
								id: String(columnList[k].id),
								isCouter: true,
								class: "tab_0",
								is_enable: true,
								color: "#888",
								iconPath: "https://diy.xiaohucloud.com/static/image/indexIcon.png",
								selectedColor: "#2873ff",
								iStyle: {},
								link: String(columnList[k].id),
								url: String(columnList[k].id)
							};
							footerItem.push(clmList);
						}
					}
					dt.mFooter({
						itemNav: footerItem,
						isShow: true
					});
					return;
				}

				if(dt.state.curOrder.mClass != "Typesetting") {
					item = {
						tName: "fullScreen",
						tText: "满屏容器",
						isEdit: false,
						isShow: true,
						draging: false,
						isShowUp: false,
						isShowDown: false,
						zinStyle: {
							zIndex: 0
						},
						mImage: {
							url: "",
						},
						conStyle: {
							paddingTop: '0',
							paddingLeft: '0',
							height: 'auto',
							width: '100%',
							paddingRight: '0',
							paddingBottom: '0',
						},
						allId: "m" + dt.$utils.GenNonDuplicateID(),
						mClass: "Typesetting",
						isAllSite: false,
						aloneIcon: "panelModuleIcon_multi moduleArea_multi",
						aloneText: "moduleAloneText",
						itemInner: []
					}
					dt.state.curOrder.allId = "m" + dt.$utils.GenNonDuplicateID();
					item.itemInner.push(dt.state.curOrder);
				} else {
					item = dt.state.curOrder;
				}

				if(item.tName == "swiperContainer") {
					console.log("swiperContainer");
					for(let i = 0; item.labelTitle.length > i; i++) {
						item.labelTitle[i].zinStyle.width = "100%";
					}
					$("body").addClass("swiperHover");
				}

				if(stream.length > 1) {
					stream.forEach(function(v, i) {
						if(i == 0) {
							v.isShowUp = false;
							v.isShowDown = true;
						} else {
							v.isShowUp = true;
							v.isShowDown = true;
						}
					});

					item.isShowUp = true;
					item.isShowDown = false;

				}
				var item = JSON.parse(JSON.stringify(item));
				item.allId = "m" + dt.$utils.GenNonDuplicateID();
				//debugger
				dt.pushItemStream(item);
				dt.setCurOrder(null);
			},
			removeComponent(comp) {
				let ts = this;
				ts.delItemStream(comp);
				ts.orderbyId();
			},
			setUpDown(i, flag) {
				let ts = this;
				var stream = ts.getDataCur.stream;
				var k = stream.indexOf(i);
				var obj = {
					k: k,
					j: k + flag
				}
				ts.change(obj);
				stream.forEach(function(v, i) {
					if(i == 0) {
						v.isShowUp = false;
						v.isShowDown = true;
					} else if(i == stream.length - 1) {
						v.isShowUp = true;
						v.isShowDown = false;
					} else {
						v.isShowUp = true;
						v.isShowDown = true;
					}
				});
			},
			/*delModule(item) {
				let ts = this;

			},*/
			delModule(item) {
				let ts = this;
				if(item.tName == "footerNav") {
					ts.state.footer.isShow = false;
					return;
				}
				//var stream = ts.getDataCur.stream;
				//stream.splice(stream.indexOf(item), 1);
				//ts.orderbyId();
				let obj = {
					id: ts.param.id,
					type: ts.param.type,
					order: item
				}
				ts.delStreamModule(obj);
				ts.orderbyId();
				ts.saveloca(ts.param);
			},
			inAddNewOver(event) {
				event.preventDefault();
			},
			...mapActions([
				"getData", "saveloca"
			]),
			...mapMutations([
				'orderbyId', 'mFooter', 'getAllLocalData', 'setDelayed', 'delItemPos', 'copyModule', 'delStreamModule', 'getAllSite', 'setCurOrder', 'setItemSite', 'pushItemStream', 'pushItemPosCom', 'pushItemStreamItem', 'delItemStream', 'change'
			])
		},
		computed: {
			activeRoute() {
				return this.param.param;
			},
			...mapGetters(["state", "getDataCur", "router", "phoneNav", "itemCon"])
		}
	}
</script>
<style lang="scss" scoped>
	.hideStat {
		background: #e6e6e6;
	}

	.ms1_nav ul.navItem {
		overflow: inherit;
	}

	.swiperHover .swiperContainer {
		height: 610px;
	}

	#mltilingual {
		position: relative;
		.edit_con {
			position: absolute;
			background: #FFFFFF;
			border-radius: 5px;
			box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.2);
			padding: 0 15px;
			top: -40px;
			width: 200px;
			height: 40px;
			line-height: 40px;
			display: none;
			span {
				float: left;
				cursor: pointer;
				border-right: 1px solid #E3E3E3;
				margin: 0 8px;
			}
			span:nth-child(1) {
				padding-right: 7px;
				line-height: 25px;
				margin-top: 8px;
			}
			.icon {
				display: block;
				float: left;
				border-right: none;
				background: url(/static/image/bg03.png) no-repeat;
			}
			.icon i {
				position: absolute;
				display: block;
				font-size: 12px;
				width: auto;
				line-height: 25px;
				padding: 0px 10px;
				background: #FFFFFF;
				border-radius: 5px;
				box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.1);
				top: -23px;
				margin-left: -25px;
				display: none;
			}
			.style {
				background-position: -60px -186px;
				width: 21px;
				height: 21px;
				margin-top: 10px;
			}
			.style:hover {
				background-position: -60px -232px;
			}
			.style:hover i {
				display: block;
			}
			.animation {
				background-position: -372px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.animation:hover {
				background-position: -372px -232px;
			}
			.animation:hover i {
				display: block;
			}
			.borderhid {
				background-position: -275px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.borderhid:hover {
				background-position: -275px -232px;
			}
			.borderhid:hover i {
				display: block;
			}
			.delete {
				background-position: -105px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.delete:hover {
				background-position: -105px -232px;
			}
			.delete:hover i {
				display: block;
			}
		}
	}

	#mltilingual:hover {
		.edit_con {
			display: block;
		}
	}

	.navheader .placeholderTxt {
		width: 380px;
	}

	.navheader {
		z-index: 0 !important;
		position: absolute !important;
	}

	.containerp {
		width: 420px;
		height: 804px;
		overflow-y: hidden;
		overflow-x: hidden;
		margin-left: 25%;
		position: relative;
		background: url(/static/image/phonebg.png) no-repeat center;
	}

	.navigation.ms2_nav {
		position: absolute;
	}

	.navigation.active {
		overflow: visible;
	}

	.navheader {
		position: absolute;
		left: 0;
		top: 0;
	}

	.container2 {
		.con_innd {
			overflow: visible;
		}
	}

	.container2 .navigation {
		transform: translate(0px, 0);
		position: absolute;
	}

	.con_innd {
		margin-left: 4px;
		height: 610px;
		position: relative;
		overflow-x: hidden;
		padding-top: 60px;
		overflow-y: auto;
		margin-right: 10px;
		margin-top: 55px;
	}

	.containerp .conect_inner {
		overflow: visible;
		background-color: #fff;
		position: relative;
		margin-top: 0;
		height: auto !important;
		margin-right: auto;
		.columnLayout {
			position: relative;
			margin-left: -45%;
			margin-right: -45%;
		}
		.con_innd {}
	}

	.in_outer {
		position: relative;
	}

	.pos_con {
		.inner {
			width: 100%;
			margin: 0 auto;
		}
	}

	.containerp .warning {
		border: 1px dashed red;
	}

	.in_inner {
		border: 1px dashed #FFFFFF;
		.resizeMe {
			position: relative;
			left: 0 !important;
			top: 0 !important;
			box-sizing: border-box;
		}
		.del_icon {
			text-align: left;
		}
		.multi_edit {
			position: absolute;
			z-index: 0;
			top: -40px;
			width: auto;
			height: 40px;
			line-height: 40px;
			display: none;
			background: #FFFFFF;
			border-radius: 5px;
			box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.15);
			padding: 0 10px;
			span {
				float: left;
				cursor: pointer;
				margin-right: 10px;
				margin-left: 5px;
			}
			span:nth-child(1) {
				line-height: 25px;
				border-right: 1px solid #E3E3E3;
				margin-top: 7px;
				padding-right: 8px;
				margin-left: 10px;
			}
			.icon {
				background: url(/static/image/bg03.png) no-repeat;
			}
			.icon i {
				position: absolute;
				display: block;
				font-size: 12px;
				width: auto;
				line-height: 25px;
				padding: 0px 10px;
				background: #FFFFFF;
				border-radius: 5px;
				box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.1);
				top: -23px;
				margin-left: -25px;
				display: none;
			}
			.style {
				display: block;
				background-position: -64px -186px;
				width: 21px;
				height: 21px;
				margin-top: 10px;
			}
			.style:hover {
				background-position: -64px -232px;
			}
			.style:hover i {
				display: block;
			}
			.animation {
				display: block;
				background-position: -372px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.animation:hover {
				background-position: -372px -232px;
			}
			.animation:hover i {
				display: block;
			}
			.borderhid {
				display: block;
				background-position: -275px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.borderhid:hover {
				background-position: -275px -232px;
			}
			.borderhid:hover i {
				display: block;
			}
			.delete {
				display: block;
				background-position: -108px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.delete:hover {
				background-position: -108px -232px;
			}
			.delete:hover i {
				display: block;
			}
		}
	}

	.multi_con {
		position: relative;
	}

	.in_inner:hover {
		border-color: #5874d8;
		.clm {
			border-color: #5874d8;
		}
		.multi_edit {
			display: block;
		}
	}

	.multi_con {
		height: auto;
		.clm {
			border: 1px dashed #fff;
			height: auto;
			position: relative;
			.area_conn {
				min-height: 120px;
			}
			.dragNew {
				position: absolute;
				bottom: 8px;
				width: 100%;
			}
		}
	}

	#labelTitle {
		/*display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
		text-align: center;
		width: auto;
		margin-bottom: 0;
		position: relative;*/
		.labelList {
			/*float: left;*/
			text-align: center;
			z-index: auto;
			box-sizing: border-box;
			.title {
				position: relative;
				cursor: pointer;
				width: 100%;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				i {
					position: absolute;
					top: 0px;
					right: 10px;
					line-height: 20px;
					display: none;
				}
			}
			.title:hover i {
				display: block;
			}
			.ateralLabel {
				display: none;
				position: absolute;
				width: 100%;
				left: 0;
				right: 0;
				z-index: 99;
				background: #FFFFFF;
				margin-top: 10px;
			}
		}
		.addTitle {
			background: #409EFF;
			float: left;
			color: #FFFFFF;
			font-size: 12px;
			padding: 0 5px;
			border-radius: 5px;
			margin-left: 5px;
			line-height: 40px;
		}
		.cur .title {
			background: red !important;
			color: #FFFFFF !important;
		}
	}

	.longitud {
		.tit_con {
			float: left;
			width: 20%;
			ul {}
		}
		.long_con {
			float: left;
			width: 80%;
		}
	}

	.ateralLabel {
		ul {
			li {
				float: left;
				width: 100px;
				text-align: center;
			}
		}
		.long_con {}
	}

	.containerp .enter {
		border: #5874d8 1px dashed;
	}

	.dragNew {
		min-height: 70px;
		padding-top: 20px;
		padding-bottom: 10px;
		text-align: center;
		border: 1px dashed #CCC;
		p {
			text-align: center;
			cursor: pointer;
			width: 132px;
			margin: 0 auto;
			height: 50px;
			background: url(/static/image/mbg01.png) no-repeat;
			background-position: -611px -348px;
			margin-bottom: 5px;
		}
	}

	.dragNew:hover {
		border: 1px dashed #5874d8;
	}

	.dragNew:hover p {
		background-position: -611px -400px;
	}

	.columnLayoutInner {
		width: 100%;
		margin: 0 auto;
	}

	.activ_con {
		position: absolute;
		right: 0;
		top: 0;
		z-index: 6;
		width: 30px;
		.down_icon {
			height: 30px;
			cursor: pointer;
			display: block;
			width: 30px;
			background: url(/static/image/down_icon.png) no-repeat 0 0;
		}
		.up_icon {
			height: 30px;
			display: block;
			cursor: pointer;
			width: 30px;
			background: url(/static/image/up_icon.png) no-repeat 0 0;
		}
	}

	.conectBar {
		position: relative;
		overflow: hidden;
	}

	.nav-footer {
		position: absolute;
		bottom: 0;
		width: 405px;
		z-index: 333;
		margin-left: 5px;
		left: 0;
	}

	.nav-footer:hover .edit_con {
		display: block;
	}

	.addMern {
		width: 100%;
		margin: 0 auto;
	}

	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background-color: #b2b2b2;
		width: 16px;
		-webkit-border-radius: 16px;
		-moz-border-radius: 16px;
		border-radius: 16px;
	}
</style>



// WEBPACK FOOTER //
// src/components/t2/index.vue